import React from 'react';
import OKA from '@api';
import store from 'store2';
import moment from 'moment';
import config from '@root/config';
import to from 'await-to-js';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

const InitContext = React.createContext();


class InitProvider extends React.Component {
    state = {
        loaded: false,
        settings: {
            logo: ``,
            fcname: '',
            theme: '#008b63'
        }
    };

    componentDidMount() {
        const { facility } = this.props;
        this.init(facility);
    }

    reloadCache = async(facility) => {
        const { settings } = this.state;
        const [err, resp] = await to(OKA.locale.GetInit({ facility_id: facility }));
        if (!err) {
            settings.fcname = _get(resp, 'data.data.settings.facility_name');
            settings.logo = _get(resp, 'data.data.settings.facility_logo');
            settings.theme = _get(resp, 'data.data.settings.facility_theme') || '#008b63';
            settings.qms_configs =  _get(resp, 'data.data.settings.qms_configs') || {};
            store.local.set(`antrian.okadoc.setting${facility}`, {
                ...settings,
                expired: moment().add(3, 'hours').toISOString()
            });            
        }
        this.setState({
            settings
        });
    }

    async init(facility) {
        await OKA.init(config.api, config.clientId);
        
        let settingsCache = {};
        try {
            settingsCache = store.local.get(`antrian.okadoc.setting${facility}`);
            if (_isEmpty(settingsCache)) {
                settingsCache = JSON.parse(settingsCache);
            }
            // eslint-disable-next-line no-empty
        } catch (error) {
            settingsCache = {}
        }

        let { settings } = this.state;

        if (settingsCache && settingsCache.logo) {
            settings = settingsCache;
            if (moment().add(1, 'hours') > moment(settingsCache.expired)) {
                this.reloadCache(facility);
            }
        } else {
            this.reloadCache(facility);
        }
        this.setState({
            loaded: true,
            settings
        });
    }

    render() {
        const value = {
            ...this.state,
            actions: {}
        };
        
        return (
            <InitContext.Provider value={value}>{this.props.children}</InitContext.Provider>
        );
    }
}

export {InitProvider, InitContext};